/** Client / file from the current URL, for quick capture defaults (PRD-017 §3.13). */
export function scopeFromPath(pathname: string): { clusterId: string | null, fileId: string | null } {
  const m = /^\/c\/([^/]+)(?:\/f\/([^/]+))?/.exec(pathname)
  return { clusterId: m?.[1] ?? null, fileId: m?.[2] ?? null }
}
